export default {
  'bankAccounts.searchBar.create': 'New Bank Account',
  'bankAccounts.filter.order': 'Order by',
  'bankAccounts.filter.order.options.asc': 'Asc',
  'bankAccounts.filter.order.options.desc': 'Desc',
  'bankAccounts.list.header.bank': 'Bank',
  'bankAccounts.list.header.bankCode': 'Bank Code',
  'bankAccounts.list.header.agency': 'Agency',
  'bankAccounts.list.header.account': 'Account',
  'bankAccounts.list.header.description': 'Description',
  'bankAccounts.list.header.actions': 'Actions',
  'bankAccounts.list.column.actions.details': 'View/Edit',
  'bankAccounts.form.bank': 'Bank',
  'bankAccounts.form.address': 'Address',
  'bankAccounts.form.address.zipCode': 'Zip Code',
  'bankAccounts.form.address.district': 'District',
  'bankAccounts.form.address.uf': 'UF',
  'bankAccounts.form.address.city': 'City',
  'bankAccounts.form.address.street': 'Street',
  'bankAccounts.form.address.number': 'Number',
  'bankAccounts.form.address.complement': 'Complement',
  'bankAccounts.form.contactList': 'Contacts',
  'bankAccounts.form.contactList.status': 'Status',
  'bankAccounts.form.contactList.status.active': 'Active',
  'bankAccounts.form.contactList.status.inactive': 'Inactive',
  'bankAccounts.form.contactList.contactType': 'Contact Type',
  'bankAccounts.form.contactList.contactType.email': 'Email',
  'bankAccounts.form.contactList.contactType.mobile': 'Mobile',
  'bankAccounts.form.contactList.contactType.fax': 'Fax',
  'bankAccounts.form.contactList.contactType.phone': 'Phone',
  'bankAccounts.form.contactList.contactType.whatsapp': 'Whatsapp',
  'bankAccounts.form.contactList.value': 'Value',
  'bankAccounts.form.contactList.addItem': 'Add Item',

  'bankAccounts.status.message.success':
    'Bank Account Status Changed Successfully!',

  'bankAccounts.create.notification.success': 'Bank Account added!',
  'bankAccounts.create.notification.successDescription':
    'The Bank Account has been successfully added!',

  'bankAccounts.update.notification.success': 'Success',
  'bankAccounts.update.notification.successDescription':
    'Bank account updated successfully!',

  'bankAccounts.remove': 'Remove Bank Account',
  'bankAccounts.remove.modal.content':
    'Are you sure you want to remove the Bank Account?',
  'bankAccounts.remove.notification.success': 'Bank account removed!',
  'bankAccounts.remove.notification.successDescription':
    'Successfully removed bank account!',
  'bankAccounts.remove.modal.button.ok': 'Remove',

  'bankAccounts.remove.error.delete.constraint':
    'It is not possible to delete a Bank Account that is linked to another module!',
};
